// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LjMYP","card":"uCE31","flipped":"bU9iL","card_inner":"iO6Cd","close_ad":"NKO3O","card_face":"CmysT","card_front":"jD3Mp","card_back":"UaCD3","upsidedown":"vHAbs"};